import React from 'react';
import './AboutProviders.scss';

const AboutProviders: React.FC = () => {
  return (
    <div className="providers-container">
      <div className="providers-header">
        <h1>Our Providers</h1>
        <p>Meet our experienced team of mental health professionals dedicated to your well-being</p>
      </div>

      <div className="providers-sections">
        <section className="provider-section">
          <div className="provider-content">
            <div className="provider-image-wrapper">
              <div className="provider-image">
                <img src="/assets/images/tatini_prasanti_1978.jpg" alt="Prasanti Tatini, M.D." />
              </div>
            </div>
            <div className="provider-text">
              <h2>Prasanti Tatini, M.D.</h2>
              <h3>Board Certified General and Geriatric Psychiatrist</h3>
              <p className="provider-bio">
                Prasanti Tatini is a Board Certified General and Geriatric Psychiatrist in Tallahassee, FL. She attended medical school at the Mahadevappa Rampure Medical College in Karnataka, India, received psychiatric training at Michigan State University in Kalamazoo, MI, as well as a Geriatric Psychiatry Fellowship from Harvard University (partners program) in Boston, MA and has been responsible for inpatient and outpatient psychiatry programs for almost a decade. She is certified to perform both ECT and TMS treatments and served many years as Medical Director of the Psychiatry Department at Tallahassee Memorial. Dr. Tatini is a thoughtful and attentive listener who is passionate about helping her patients to create personal outlooks that promote mental well-being. When asked what inspired her to open FFPS, she responded, "I wanted to put myself in a position to be able to prioritize each of my patients' needs."
              </p>
              <div className="provider-credentials">
                <p><strong>Specialties:</strong> General Psychiatry, Geriatric Psychiatry, ECT and TMS Treatments</p>
                <p><strong>Education:</strong> Medical School - Mahadevappa Rampure Medical College, Karnataka, India; Psychiatric Training - Michigan State University, Kalamazoo, MI; Geriatric Psychiatry Fellowship - Harvard University (Partners Program), Boston, MA</p>
                <p><strong>Certifications:</strong> Board Certified General Psychiatrist, Board Certified Geriatric Psychiatrist</p>
                <p><strong>Experience:</strong> Medical Director of Psychiatry Department at Tallahassee Memorial; Nearly a decade of experience in inpatient and outpatient psychiatry programs</p>
              </div>
            </div>
          </div>
        </section>

        <section className="provider-section alternate">
          <div className="provider-content">
            <div className="provider-image-wrapper">
              <div className="provider-image">
                <img src="/assets/images/Marie_Myrick.jpg" alt="Marie Myrick" />
              </div>
            </div>
            <div className="provider-text">
              <h2>Marie Myrick, DNP, APRN, PMHNP-BC</h2>
              <h3>Psychiatric Mental Health Nurse Practitioner</h3>
              <p className="provider-bio">
                I am a board certified Psychiatric Mental Health Nurse Practitioner, experienced in the mental health field with both children and adult patient care. I received my Bachelor of Science in Nursing at Chamberlain University while working inpatient as a Nurse Manager in Gainesville, Florida. While attending Graduate School through Walden University, I was the Director of Nursing for Behavioral Health at a local hospital in Tallahassee, Florida. I completed my Doctorate in Nursing Practice at Chamberlain University.
              </p>
              <p className="provider-bio">
                I focus on the treatment of mood disorders, trauma, psychotic disorders, substance abuse and chronic mental illness through psychiatric assessment, medication management and brief supportive psychotherapy for clients ages 10 and above. I do this by creating an individualized plan of care that values client involvement, inter-professional collaboration and evidenced-based practice. Through supportive education in a patient-centered environment, I feel my clients will be empowered to treat their illness.
              </p>
              <div className="provider-credentials">
                <p><strong>Specialties:</strong> Mood Disorders, Trauma, Psychotic Disorders, Substance Abuse, Chronic Mental Illness</p>
                <p><strong>Patient Age Range:</strong> Ages 10 and above</p>
                <p><strong>Education:</strong> Bachelor of Science in Nursing - Chamberlain University; Graduate Studies - Walden University; Doctorate in Nursing Practice - Chamberlain University</p>
                <p><strong>Certifications:</strong> Board Certified Psychiatric Mental Health Nurse Practitioner (PMHNP-BC)</p>
                <p><strong>Experience:</strong> Nurse Manager (Inpatient), Director of Nursing for Behavioral Health</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutProviders;

